import { render, staticRenderFns } from "./ViewDpaAccountComponent.vue?vue&type=template&id=87225942&"
import script from "./ViewDpaAccountComponent.vue?vue&type=script&lang=js&"
export * from "./ViewDpaAccountComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports